import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignVerticalJustifyEnd: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '5', y: '12', width: '14', height: '6', rx: '2' }],
    ['rect', { x: '7', y: '2', width: '10', height: '6', rx: '2' }],
    ['path', { d: 'M2 22h20' }],
  ],
];

export default AlignVerticalJustifyEnd;
